import React from "react";

import Item from "../Item/Item";
import Axios from "axios";

export default class Column extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			newItemTitle: "",
			value: "",
		};

		this.newItemContentHandler = this.newItemContentHandler.bind(this);
		this.createNewItem = this.createNewItem.bind(this);
	}

	newItemContentHandler = (event) => {
		this.setState({ newItemTitle: event.target.value });
	};

	createNewItem = (event) => {
		if (event.key === "Enter") {
			if (this.state.newItemTitle !== "") {
				const url = `http://sys.niroomohareke.ir/backend/api/create-${this.props.content.category}`;
				Axios.post(url, { title: this.state.newItemTitle }).then((response) => {
					this.setState({ newItemTitle: "" });
				});
			} else {
				console.error("باید مقداری را وارد کنید");
			}
		}
	};

	render() {
		const renderItems = this.props.content.items.map((item) => (
			<Item key={item.id} category={this.props.content.category} item={item} />
		));
		return (
			<section className="w-1/3 mb-4 md:mb-0 md:mx-2 rounded bg-gray-100 md:bg-gray-200 p-3 border shadow">
				<div className="w-full font-medium mb-4">
					<p>{this.props.content.title}</p>
				</div>
				{renderItems}

				<input
					value={this.state.newItemTitle}
					onChange={this.newItemContentHandler}
					onKeyPress={this.createNewItem}
					className="w-full outline-none p-3 bg-white rounded"
					placeholder="اضافه کردن آیتم جدید"
				/>
			</section>
		);
	}
}
